import styled from "styled-components";
import { Button } from "react-bootstrap";

const OnboardingButtonPrimary = styled(Button)`
  background-color: #c3af83;
  border-radius: 4px;
  border: 0px;
  color: #000000;
  padding: 9px 16px;
  font-family: Manrope, sans-serif;
  &&:hover {
    background-color: #c3af83;
  }
  &&:disabled {
    background-color: #c3af83;
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export { OnboardingButtonPrimary };

const OnboardingButtonOutlined = styled(Button)`
  background-color: white;
  border: 2px solid #010b18ad;
  border-radius: 4px;
  color: #000000;
  font-weight: 600;
  font-size: 18px;
  height: 48px;
  font-family: Manrope, sans-serif;

  &&:hover {
    background-color: #c3af83;
    border-color: #000000;
  }
  
  &&:disabled {
    background-color: white;
    border-color: #010b18ad;
    color: #000000;
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export { OnboardingButtonOutlined };

const OnboardingButtonLink = styled(Button)`
  background: none;
  border: none;
  color: #000000;
  text-decoration: underline;
  padding: 0;
  font-weight: 600;
  font-size: 18px;
  text-align: left;
  font-family: Manrope, sans-serif;

  &&:hover {
    color: #000000;
    background-color: transparent;
  }

  &&:focus {
    color: #000000;
    background-color: transparent;
  }
`;

export { OnboardingButtonLink };

const OnboardingButtonExternalLink = styled.a`
  background-color: #c3af83;
  border-radius: 4px;
  border: 0px;
  color: #000000;
  padding: 9px 16px;
  font-family: Manrope, sans-serif;
  text-decoration: none;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #c3af83;
    color: #000000;
    text-decoration: none;
  }

  &:focus {
    background-color: #c3af83;
    color: #000000;
    text-decoration: none;
  }
`;

export { OnboardingButtonExternalLink };

const OnboardingButtonExternalLinkOutlined = styled.a`
  background-color: white;
  border: 2px solid #010b18ad;
  border-radius: 4px;
  color: #000000;
  font-weight: 600;
  font-size: 18px;
  min-height: 48px;
  font-family: Manrope, sans-serif;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 9px 16px;

  &:hover {
    background-color: #c3af83;
    border-color: #000000;
    color: #000000;
    text-decoration: none;
  }

  &:focus {
    background-color: #c3af83;
    border-color: #000000;
    color: #000000;
    text-decoration: none;
  }
`;

export { OnboardingButtonExternalLinkOutlined };
